import { applyStrings } from "../ui";

applyStrings();

// Fecha o menu compacto ao escolher uma seção.
const menu = document.querySelector<HTMLDetailsElement>(".site-menu");
menu?.addEventListener("click", (e) => {
  if ((e.target as Element).closest("a")) menu.open = false;
});
menu?.addEventListener("keydown", (e) => {
  if (e.key !== "Escape" || !menu.open) return;
  menu.open = false;
  menu.querySelector("summary")?.focus();
});
